import { corners, media, padding } from "../../../styles";
import styled from "styled-components";
export const ListItem = styled.li`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  column-gap: 1rem;
  row-gap: 1rem;

  border: 1px solid ${({
  theme
}) => theme.brand.cssVars["--d-border"]};
  ${corners.m}
  ${padding.m}

  @media ${media.mobile} {
    flex-direction: column;
    align-items: stretch;
    border: none;
    border-radius: 0;
    ${padding.zero}
  }
`;
export default ListItem;